import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home
  // },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/layout.vue'),
    redirect: "home",
    children: [
      {
        path: 'home',
        name: 'Home',
        component: Home,
        redirect: "customer",
      },
      {
        path: '/material',
        name: 'Material',
        component: () => import('../views/Material.vue')
      },
      {
        path: '/customer',
        name: 'Customer',
        component: () => import('../views/erp/customer')
      }
      ,
      {
        path: '/supplier',
        name: 'Supplier',
        component: () => import('../views/erp/supplier')
      },
      {
        path: '/supplier/detail',
        name: 'SupplierDetail',
        component: () => import('../views/erp/supplier/detail')
      },
      {
        path: '/order',
        name: 'Order',
        meta: {
          keepAlive: true // 开启缓存
        },
        component: () => import('../views/erp/order')
      },
      {
        path: '/orderPlan',
        name: 'OrderPlan',
        meta: {
          keepAlive: true // 开启缓存
        },
        component: () => import('../views/OrderPlan.vue')
      },
      {
        path: '/order/qrcode',
        name: 'QRcode',
        component: () => import('../views/erp/order/qrcode')
      },
      {
        path: '/order/plan/create/:orderNo',
        name: 'OrderPlanCreate',
        component: () => import('../views/OrderPlanCreate.vue')
      },
      {
        path: '/order/insert',
        name: 'OrderInsert',
        component: () => import('../views/OrderInsert.vue')
      },
      {
        path: '/order/detail/:orderNo',
        name: 'OrderDetail',
        component: () => import('../views/OrderDetail.vue')
      },
      {
        path: '/order/plan/bucketLabelPrint',
        name: 'BucketLabelPrint',
        component: () => import('../views/BucketLabelPrint.vue')
      },
      {
        path: '/delivery',
        name: 'Delivery',
        meta: {
          keepAlive: true // 开启缓存
        },
        component: () => import('../views/erp/delivery')
      },
      {
        path: '/delivery/create',
        name: 'DeliveryCreate',
        component: () => import('../views/DeliveryCreate.vue')
      },
      {
        path: '/delivery/detail/:id',
        name: 'DeliveryDetail',
        component: () => import('../views/DeliveryCreate.vue')
      },
      {
        path: '/receivable',
        name: 'Receivable',
        meta: {
          keepAlive: true // 开启缓存
        },
        component: () => import('../views/erp/finance/receivable')
      },
      {
        path: '/receivable/detail/:id',
        name: 'ReceivableDetail',
        component: () => import('../views/erp/finance/receivable/add')
      },
      {
        path: '/receivable/add',
        name: 'ReceivableAdd',
        component: () => import('../views/erp/finance/receivable/add')
      },
      {
        path: '/receivableItem',
        name: 'ReceivableItem',
        component: () => import('../views/erp/finance/receivableItem')
      },
      {
        path: '/payable',
        name: 'Payable',
        meta: {
          keepAlive: true // 开启缓存
        },
        component: () => import('../views/erp/finance/payable')
      },
      {
        path: '/payable/detail',
        name: 'PayableDetail',
        component: () => import('@/views/erp/finance/payable/detail')
      },
      {
        path: '/yarn',
        name: 'Yarn',
        component: () => import('../views/Yarn.vue')
      },
      {
        path: 'yarnType',
        name: 'YarnType',
        component: () => import('@/views/YarnType.vue')
      },
      {
        path: '/stock',
        name: 'Stock',
        meta: {
          keepAlive: true // 开启缓存
        },
        component: () => import('@/views/erp/stock')
      },
      {
        path: '/stock/add',
        name: 'StockAdd',
        component: () => import('@/views/StockAdd.vue')
      },
      {
        path: '/stock/details/:id',
        name: 'StockDetails',
        component: () => import('@/views/StockDetails.vue')
      },
      //报表
      {
        path: '/report/order',
        name: 'orderReport',
        meta: {
          keepAlive: true // 开启缓存
        },
        component: () => import('@/views/erp/report')
      },
      //商城菜单
      {
        path: '/mp/product',
        name: 'Product',
        meta: {
          keepAlive: true // 开启缓存
        },
        component: () => import('@/views/mp/product')
      },
      {
        path: '/mp/product/detail',
        name: 'ProductDetail',
        component: () => import('@/views/mp/product/detail')
      },
      {
        path: '/mp/banner',
        name: 'Banner',
        component: () => import('@/views/mp/banner')
      },
      {
        path: '/mp/config',
        name: 'mpConfig',
        component: () => import('@/views/mp/config')
      },
      {
        path: '/mp/user',
        name: 'mpUser',
        component: () => import('@/views/mp/user')
      },
      {
        path: '/mp/suggestion',
        name: 'mpSuggestion',
        component: () => import('@/views/mp/suggestion')
      },
      //小程序
      {
        path: '/mpIndex',
        name: 'MpIndex',
        component: () => import('@/views/MpIndex.vue'),
        redirect: "mpIndex/miniPro",
        children: [
          {
            path: 'miniPro',
            name: 'MiniPro',
            component: () => import('@/views/MiniPro.vue')
          },
          {
            path: 'colorCard',
            name: 'ColorCard',
            component: () => import('@/views/ColorCard.vue')
          },
          {
            path: 'cardItem/:id',
            name: 'CardItem',
            component: () => import('@/views/CardItem.vue')
          },
          {
            path: 'cardItem',
            name: 'CardItem',
            component: () => import('@/views/CardItem.vue')
          }
        ]
      },
      {
        path: '/system',
        name: 'System',
        component: () => import('@/views/system/Index.vue'),
        redirect: "system/user",
        children: [
          {
            path: 'user',
            name: 'User',
            component: () => import('@/views/system/User.vue')
          },
          {
            path: 'permission',
            name: 'Permission',
            component: () => import('@/views/system/Permission.vue')
          },
          {
            path: 'role',
            name: 'Role',
            component: () => import('@/views/system/Role.vue')
          },
          {
            path: 'userPermission',
            name: 'UserPermission',
            component: () => import('@/views/system/UserPermission.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }

]

const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next) => {
  if (to.name == "Login"||to.path == "login") {
    //缓存之前浏览的页面
    localStorage.setItem("preRoute",from.fullPath);
  }
  next();
})
export default router
